<template>
    <div v-if="analysisData">
        <div class="rounded-lg bg-gray-50 p-3 dark:bg-gray-800">
            <div class="flex flex-col gap-2">
                <div class="flex items-center space-x-2">
                    <BoltIcon
                        v-tooltip="'Análise gerada por IA'"
                        class="h-5 w-5 text-purple-500"
                    />
                    <span
                        class="text-sm font-medium"
                        :class="{
                            'text-red-500': analysisData.confidence < 30,
                            'text-yellow-500':
                                analysisData.confidence >= 30 &&
                                analysisData.confidence < 70,
                            'text-green-500': analysisData.confidence >= 70,
                        }"
                    >
                        Confiança: {{ analysisData.confidence }}%
                    </span>
                    <span
                        :class="{
                            'text-red-500': analysisData.analysis === 'Reprovar',
                            'text-green-500':
                                analysisData.analysis === 'Aprovar' ||
                                analysisData.analysis === 'approved',
                            'text-yellow-500': analysisData.analysis === 'Atenção',
                            'dark:text-white':
                                analysisData.analysis === 'Análise manual',
                        }"
                    >
                        {{ analysisData.analysis }}
                    </span>
                </div>
                <div class="text-sm text-gray-400">
                    <TypewriterText :text="analysisData?.reason" :speed="5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BoltIcon } from "@heroicons/vue/24/solid";
import TypewriterText from "@/components/common/TypewriterText.vue";

export default {
    props: ["analysis"],
    name: "SystemAnalysis",
    components: {
        BoltIcon,
        TypewriterText,
    },

    computed: {
        analysisData() {
            // Verifica se analysis existe
            if (!this.analysis) {
                return null;
            }

            // Se for array, pega o primeiro item
            if (Array.isArray(this.analysis)) {
                return this.analysis[0] || null;
            }

            // Se for objeto, retorna diretamente
            return this.analysis;
        }
    },

    watch: {
        analysisData: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.$emit("data-loaded", newValue);
                    });
                }
            },
        },
    },

    mounted() {
        if (this.analysisData) {
            this.$emit("data-loaded", this.analysisData);
        }
    },
};
</script>
